import { render, staticRenderFns } from "./InputDetails.vue?vue&type=template&id=3000d9d2"
import script from "./InputDetails.vue?vue&type=script&lang=js"
export * from "./InputDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports